"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imageHref = exports.finproProfileImageHref = void 0;
var _utils = require("../utils");
var _lodash = require("lodash");
/**
 * Create a path to an image
 *
 * @param {object} props Sitecore image field value
 * @param {sring} env current environment
 *
 * @returns {string} A full image path
 */
var imageHref = props => {
  if ((0, _lodash.isEmpty)(props) || (0, _lodash.isEmpty)(props.src)) return null;
  if (props.src.includes('https:')) {
    var imageUrl = (0, _lodash.split)(props.src, '.com');
    return imageUrl.length > 1 ? (0, _utils.getMMDomainUrl)(imageUrl[1]) : null;
  } else return (0, _utils.getMMDomainUrl)(props.src);
};
exports.imageHref = imageHref;
var finproProfileImageHref = imgSrc => {
  if ((0, _lodash.isEmpty)(imgSrc)) return null;
  if (imgSrc.includes('https:')) {
    var imageUrl = (0, _lodash.split)(imgSrc, '.com');
    return imageUrl.length > 1 ? (0, _utils.getMMDomainUrl)(imageUrl[1]) : null;
  } else return (0, _utils.getMMDomainUrl)(imgSrc);
};
exports.finproProfileImageHref = finproProfileImageHref;